export default __webpack_public_path__ + "static/media/man1.eb607ada.png";